import { $jsonApi } from '#/api/client'

interface IETicketsAvailability {
  /** True when e-tickets are configured and orderable (active proposition + Tranzer externalId) */
  configured: boolean
  /** True once the availability check has settled (success or error) — until then the check is pending */
  isKnown: boolean
}

/**
 * Reports whether e-tickets are actually orderable for a company (DEV-2801).
 * Only queried when e-tickets are enabled in the contract. Fails closed: an
 * error (403, network) settles as not-configured, so a rejected check can
 * never leave the menu entry or route open.
 */
export const useETicketsAvailability = (companyId: string, enabled: boolean): IETicketsAvailability => {
  const { data, isSuccess, isError } = $jsonApi.useQuery(
    'get',
    '/companies/{companyId}/e-tickets/availability',
    {
      params: {
        path: { companyId },
      },
    },
    {
      enabled: enabled && companyId.length > 0,
      select: (response): boolean => response.configured,
    },
  )

  return {
    configured: data === true,
    isKnown: isSuccess || isError,
  }
}
